let $selectedCategory;
let $body;
let $filterButton;

// Close mobile filter and navigate to selected category
const _closeMobileFilterAndNavigate = () => {
  if ($selectedCategory && $selectedCategory.length > 0) {
    window.location.href = $selectedCategory.attr("href");
  } else {
    $(".js-blog-mobile-filter").hide();
    $(".js-blog-mobile-filter-open").show();
  }
  $body.css("overflow", "visible");
};

// Show/hide mobile filter button depending on window position
const _showHideFilterButton = () => {
  const footerTop = $("footer").offset().top;
  const footerBottom = $("footer").offset().top + $("footer").outerHeight();
  const windowBottom =
    $(window).scrollTop() +
    ($(window).innerHeight() - $(window).innerHeight() / 3);
  const windowTop = $(window).scrollTop();

  if (windowBottom > footerTop && windowTop < footerBottom) {
    $filterButton.css("opacity", "0");
    $filterButton.css("visibility", "hidden");
  } else {
    $filterButton.css("visibility", "visible");
    $filterButton.css("opacity", "1");
  }
};

// Show/hide menu separator depending on window position
const _showHideMenuSeparator = () => {
  const menuTop = $(".js-blog-categories").offset().top;
  const headerBottom = $("header").offset().top + $("header").outerHeight();

  if (menuTop === headerBottom) {
    $(".js-blog-categories").addClass("tw-border-t-2");
  } else {
    $(".js-blog-categories").removeClass("tw-border-t-2");
  }
};

// set filter elements and init event listeners
const _initBlogFilter = () => {
  $selectedCategory = $(".js-blog-category-link.is-selected");
  $body = $("body");
  $filterButton = $(".js-blog-mobile-filter-open button");

  // Event listener for mobile filter close button
  $(".js-blog-mobile-filter-close").click((event) => {
    _closeMobileFilterAndNavigate();
  });

  // Event listener for mobile filter open button
  $(".js-blog-mobile-filter-open").click(() => {
    if ($filterButton.css("visibility") === "visible") {
      $(".js-blog-mobile-filter").show();
      $(".js-blog-mobile-filter-open").hide();
      if ($selectedCategory.length > 0) {
        $selectedCategory.closest("details").attr("open", "");
      }
      $body.css("overflow", "hidden");
    }
  });

  // Event listener for mouseenter on category details
  $(".js-detail summary, .js-detail ul").mouseenter((event) => {
    if ($(window).width() > 1024) {
      const $currentDetail = $(event.target).closest("details");
      $currentDetail.attr("open", "");
      $(".js-blog-categories .js-detail")
        .not($currentDetail)
        .removeAttr("open");
    }
  });

  // Event listener for mouseleave on category details
  $(".js-detail ul, .js-detail summary").mouseleave((event) => {
    if ($(window).width() > 1024) {
      const $currentDetail = $(event.target).closest("details");
      $currentDetail.removeAttr("open");
      $(".js-blog-categories .js-detail")
        .not($currentDetail)
        .removeAttr("open");
    }
  });

  // Event listener for click on mobile filter category link
  $(".js-blog-mobile-filter .js-blog-category-link").click((event) => {
    event.preventDefault();
    if (
      $selectedCategory &&
      $selectedCategory.length > 0 &&
      $(event.target).attr("href") === $selectedCategory.attr("href")
    ) {
      $selectedCategory.removeClass("is-selected");
      $selectedCategory = null;
    } else {
      $selectedCategory = $(event.target);
      $(".js-blog-category-link").removeClass("is-selected");
      $selectedCategory.addClass("is-selected");
      _closeMobileFilterAndNavigate();
    }
  });

  const forceSubMenuToggle = (e) => {
    if (e.code === "Escape" || e.type === "click") {
      $(".js-blog-categories .js-detail").removeAttr("open");
    }
  };

  // Event listener for window click
  window.addEventListener("click", forceSubMenuToggle);
  // Event listener for window "Escape" keypress
  window.addEventListener("keydown", forceSubMenuToggle);

  // Event listener for click on category details
  $(".js-detail").click((event) => {
    event.stopPropagation();
  });

  // Event listener for window scroll
  $(window).scroll(() => {
    _showHideFilterButton();
    _showHideMenuSeparator();
  });
};

const _initSeeMoreBtn = () => {
  $(".js-load-more").on("click", function () {
    const pageSize = parseInt($("[data-page-size]").val());
    const totalPages = parseInt($("[data-total-pages]").val());
    const nextPage = parseInt($("[data-current-page]").val()) + 1;
    const nextUrl = $("[data-next-url]")
      .val()
      .replace(/page=[0-9]+/, "page=" + nextPage);
    $("[data-current-page]").val(nextPage);
    $.ajax({
      url: nextUrl,
      type: "GET",
      dataType: "html",
      success: function (responseHTML) {
        $(".blog-digest-articles-list").append(
          $(responseHTML).find(".blog-digest-articles-list").html()
        );
        const blogArticles = $(".blog-digest-articles-list").find(
          ".blog-article-list-item"
        );
        // Focus on the first newly addedd article
        $(blogArticles[blogArticles.length - pageSize]).focus();
        if (nextPage >= totalPages) {
          $(".js-load-more").addClass("tw-hidden");
        }
      },
    });
  });
};

document.addEventListener("DOMContentLoaded", (event) => {
  const { template } = document.body.dataset;
  if (template === "blog") _initBlogFilter();
  if (template === "blog" || template === "search") _initSeeMoreBtn();
});
